import {
    CREATE_DYEING_DC_FAILURE_DK,
    CREATE_DYEING_DC_REQUEST_DK,
    CREATE_DYEING_DC_SUCCESS_DK,
    CREATE_USER_FORM_DYEING_DC_DK,
    FETCH_SINGLE_DYEING_DC_FAILURE_DK,
    FETCH_SINGLE_DYEING_DC_REQUEST_DK,
    FETCH_SINGLE_DYEING_DC_SUCCESS_DK,
    FETCH_DYEING_DC_FAILURE_DK,
    FETCH_DYEING_DC_REQUEST_DK,
    FETCH_DYEING_DC_SUCCESS_DK,
    NAVIGATE_DYEING_DC_DETAILS_DK,
    NAVIGATE_DYEING_DC_DK,
    DYEING_DC_USERFORM_RESET_DK,
    UPDATE_DYEING_DC_FAILURE_DK,
    UPDATE_DYEING_DC_REQUEST_DK,
    UPDATE_DYEING_DC_SUCCESS_DK,
    DELETE_DYEING_DC_REQUEST_DK,
    DELETE_DYEING_DC_SUCCESS_DK,
    DELETE_DYEING_DC_FAILURE_DK,
    DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_DYEING_DC_INVOICE_REQUEST,
    FETCH_DYEING_DC_INVOICE_SUCCESS,
    FETCH_DYEING_DC_INVOICE_FAILURE,
    RESET_DYEING_DC_INVOICE,
    FETCH_DYEING_DC_STYLE_REQUEST_DK,
    FETCH_DYEING_DC_STYLE_SUCCESS_DK,
    FETCH_DYEING_DC_STYLE_FAILURE_DK
} from './dyeingDC.actionsType';

export const DYEING_DC_DK = 'dyeingDcDK';

let initialState = {
    loading: false,
    dyeingDC: [],
    dyeingDCInvoice: [],
    dyeingDCStyle: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0,
        fldDyeingOrReDyeing: 'D',
        fldNormalOrAddOnProcess: 'N'
    },
    selectedDyeingDC: {},
    detailsId: '',
    activeKey: 1,
    isDyeingDC: false,
    dyeingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let dyeingDcDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_DYEING_DC_REQUEST_DK:
        case FETCH_DYEING_DC_STYLE_REQUEST_DK:
        case FETCH_DYEING_DC_INVOICE_REQUEST:
        case CREATE_DYEING_DC_REQUEST_DK:
        case FETCH_SINGLE_DYEING_DC_REQUEST_DK:
        case UPDATE_DYEING_DC_REQUEST_DK:
        case DELETE_DYEING_DC_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_DYEING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingDC: updatePayload
            };
        case FETCH_DYEING_DC_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingDCStyle: updatePayload?.PONO
            };
        case FETCH_DYEING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingDCInvoice: updatePayload
            };

        case CREATE_DYEING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldDyeingOrReDyeing: 'D',
                    fldNormalOrAddOnProcess: 'N'
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_DYEING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedDyeingDC: updatePayload,
                userform: updatePayload
            };
        case UPDATE_DYEING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedDyeingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldDyeingOrReDyeing: 'D',
                    fldNormalOrAddOnProcess: 'N'
                },
                detailsId: ''
            };
        case DELETE_DYEING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldDyeingOrReDyeing: 'D',
                    fldNormalOrAddOnProcess: 'N'
                },
                detailsId: '',
                selectedDyeingDC: {}
            };
        case FETCH_DYEING_DC_FAILURE_DK:
        case FETCH_DYEING_DC_STYLE_FAILURE_DK:
        case FETCH_DYEING_DC_INVOICE_FAILURE:
        case FETCH_SINGLE_DYEING_DC_FAILURE_DK:
        case CREATE_DYEING_DC_FAILURE_DK:
        case UPDATE_DYEING_DC_FAILURE_DK:
        case DELETE_DYEING_DC_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_DYEING_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case DYEING_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldDyeingOrReDyeing: 'D',
                    fldNormalOrAddOnProcess: 'N'
                },
                selectedDyeingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_DYEING_DC_DETAILS_DK:
            return {
                ...state,
                isDyeingDC: true,
                dyeingDCSelectedValue: updatePayload.dyeingDCSelectedValue
            };
        case NAVIGATE_DYEING_DC_DK:
            return {
                ...state,
                isDyeingDC: false
            };
        case RESET_DYEING_DC_INVOICE:
            return {
                ...state,
                dyeingDCInvoice: []
            };
        case DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldDyeingOrReDyeing: 'D',
                    fldNormalOrAddOnProcess: 'N'
                },
                activeKey: 2
            };
        case DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldDyeingOrReDyeing: 'D',
                    fldNormalOrAddOnProcess: 'N'
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
